import React, { useEffect, useRef } from 'react';
import { AlertCircle } from 'lucide-react';

export interface ErrorBannerProps {
	message: string;
	children?: React.ReactNode;
}

export function ErrorBanner({ message, children }: ErrorBannerProps) {
	const elementRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (elementRef.current) {
			elementRef.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [message]);

	return (
		<div className="mb-6 flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 p-4" ref={elementRef}>
			<AlertCircle className="mt-0.5 size-5 shrink-0 text-red-600" />
			<div>
				<h3 className="mb-1 text-sm font-semibold text-red-900">{message}</h3>
				{children}
			</div>
		</div>
	);
}
